import Positions from '../../../../store/billing/positions';

export class AbstractEditorController {
    constructor($injector) {
        this.injector = $injector;
        this.api = this.injector.get('$http');
        this.state = this.injector.get('$state');
        this.stateParams = this.injector.get('$stateParams');
        this.alert = this.injector.get('Alert');
        this.growl = this.injector.get('growl');
        this.acl = this.injector.get('Acl');
        this.navHelper = this.injector.get('NavHelper');

        this.billingPositionConfig = {
            store: new Positions(this.injector.get('Position'), {
                injector: this.injector
            }),
            valueField: 'id',
            displayField: 'title'
        };

        this.currentActiveType = null;
        this.availableTypes = [];
        this.customObjectMeta = [];
        this.typeSelectionDisabled = false;

        this.headline = 'Edit Bookable-object';
    }

    _loadObject() {
        return this.api.get(`bo/objects/${this.stateParams.objectId}`).then((response) => {
            this.objectModel = response.data.data;
            this._prepareCustomObjectMetaDefinition();
            this._loadAvailableTypes();
            this._updateNavigation();
        }, () => {
            this.alert.error('Error', 'Error while loading bookable object');
            this.state.back();
        });
    }

    _loadOption() {
        return this.api.get(`bo/objects/${this.stateParams.objectId}/options/${this.stateParams.id}`).then((response) => {
            this.model = this._prepareModelFromApi(response.data.data);
            this._loadAvailableTypes();
        }, () => {
            this.alert.error('Error', 'Error while loading bookable object');
            this.state.back();
        });
    }

    _loadAvailableTypes() {
        return this.api.get(`bo/objects/types`).then((response) => {
            this.availableTypes = response.data.data;
            this._updateCurrentActiveType();
        }, () => {
            this.alert.error('Error', 'Error while loading available types. Please try again.');
            this.state.back();
        });
    }

    _prepareCustomObjectMetaDefinition() {
        this.customObjectMeta = [];
        _.each(this.objectModel.meta, (meta) => {
            if (meta.key.startsWith('option_custom_') && meta.key.endsWith('_definition')) {
                const customNumber = meta.key.replace('option_custom_', '').replace('_definition', ''),
                    newMeta = _.clone(meta.value);

                newMeta.key = 'custom_' + customNumber;
                newMeta.name = newMeta.label;
                delete newMeta.label;

                this.customObjectMeta.push(newMeta);
            }
        });
    }

    _updateCurrentActiveType() {
        if (!this.objectModel || !this.objectModel.type || this.availableTypes.length === 0) {
            return;
        }

        _.each(this.availableTypes, (typeInfo) => {
            if (typeInfo.key === this.objectModel.type) {
                this.currentActiveType = _.cloneDeep(typeInfo);
            }
        });
    }

    _prepareModelForApi() {
        const data = _.cloneDeep(this.model);

        return data;
    }

    _prepareModelFromApi(apiData) {
        const out = _.cloneDeep(apiData),
            oldMeta = out.meta;

        delete out.meta;
        out.meta = {};
        out.meta_translated = {};
        _.each(oldMeta, (metaInfo) => {
            out.meta[metaInfo.key] = metaInfo.value;
            out.meta_translated[metaInfo.key] = metaInfo.value_translated;
        });

        return out;
    }

    updateSelectedType(newValue) {
        this.model.type = newValue;
        this._updateCurrentActiveType();
    }

    updateMetaValue(newValue, metaField) {
        this.model.meta[metaField] = newValue;
    }

    updateTranslatedMetaValue(newValue, metaField) {
        this.model.meta_translated[metaField] = newValue;
    }

    _updateNavigation() {
        if (!this.model) {
            return;
        }

        this.navHelper.setTranslationsParamsForEntry('settings.custom_defaults.bo-objects.details.main', {
            name: this.objectModel.label
        });
    }
}

AbstractEditorController.$inject = [
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/bo/options/controllers/abstract-editor-controller.js